var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": _vm.formLabelWidth }
              },
              [
                _c("p", [_vm._v("波次分播设置")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "开启自动结束分播:" } },
                  [
                    _c("el-switch", {
                      on: { change: _vm.change1 },
                      model: {
                        value: _vm.form.auto_close,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "auto_close", $$v)
                        },
                        expression: "form.auto_close"
                      }
                    }),
                    _vm._v(
                      "\n          （开启后，当拣货明细=分播明细时，每隔5分钟进行自动结束分播相关拣货任务）\n        "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("\n            “未处理”备注的波次"),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("不可以")
                      ]),
                      _vm._v("正常分播\n          ")
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: { "inactive-value": "0", "active-value": "1" },
                      on: { change: _vm.changeUnHandleRemark },
                      model: {
                        value: _vm.unHandleRemark,
                        callback: function($$v) {
                          _vm.unHandleRemark = $$v
                        },
                        expression: "unHandleRemark"
                      }
                    }),
                    _vm._v(
                      "\n          （开启后，有备注且备注状态为“未处理”的中分位状态不能变为“去分播”、备注状态为“未处理”的波次将会被分播到异常格口、"
                    ),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("PDA分播将报错")
                    ]),
                    _vm._v("）\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(
                        "\n            囤货标记的波次是否生成上架任务，且完成分播后提示上架\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: {
                        "inactive-value": _vm.STOCK_REMARK.CLOSED,
                        "active-value": _vm.STOCK_REMARK.OPEN
                      },
                      on: { change: _vm.changeStockRemark },
                      model: {
                        value: _vm.stockRemark,
                        callback: function($$v) {
                          _vm.stockRemark = $$v
                        },
                        expression: "stockRemark"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        "(开启后，有囤货标记的波次进行分播会生成囤货上架任务，且完成分播后需绑定容器)"
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e985839", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e985839","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/CutSetting.vue
// module id = null
// module chunks = 